module.exports = __webpack_public_path__ + "files/822fa4e6303a2a6be3a5bc11594add38.png";